/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved. 
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Runtime config is frontend/config/sites.js — keep phonePrefix in sync there.

// Provide the sites for your app. Each site includes site id, and its localization configuration.
// You can also provide aliases for your locale. They will be used in place of your locale id when generating paths across the app
module.exports = [
    {
        id: 'DynamiteGarageUK',
        l10n: {
            supportedCurrencies: ['GBP', 'CAD', 'EUR', 'AUD'],
            defaultCurrency: 'GBP',
            defaultLocale: 'en-GB',
            supportedLocales: [
                {
                    id: 'en-GB',
                    alias: 'uk',
                    preferredCurrency: 'GBP',
                    actualCurrency: 'GBP',
                    countryCode: 'GB',
                    phonePrefix: '+44'
                },
                {
                    id: 'de-AT',
                    alias: 'at',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'AT',
                    phonePrefix: '+43'
                },
                {
                    id: 'de-DE',
                    alias: 'de',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'DE',
                    phonePrefix: '+49'
                },
                {
                    id: 'en-IE',
                    alias: 'ie',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'IE',
                    phonePrefix: '+353'
                },
                {
                    id: 'it-IT',
                    alias: 'it',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'IT',
                    phonePrefix: '+39'
                },
                {
                    id: 'nl-NL',
                    alias: 'nl',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'NL',
                    phonePrefix: '+31'
                },
                {
                    id: 'nl-BE',
                    alias: 'be',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'BE',
                    phonePrefix: '+32'
                },
                {
                    id: 'en-AU',
                    alias: 'au',
                    preferredCurrency: 'AUD',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'AU',
                    phonePrefix: '+61'
                },
                {
                    id: 'es-ES',
                    alias: 'es',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'ES',
                    phonePrefix: '+34'
                },
                {
                    id: 'fr-FR',
                    alias: 'fr',
                    preferredCurrency: 'EUR',
                    actualCurrency: 'CAD',
                    isFixedPriceModel: true,
                    isSupportedByESW: true,
                    countryCode: 'FR',
                    phonePrefix: '+33'
                }
            ],
            brands: [
                {
                    id: 'garage',
                    rootCategory: 'root_gar_uk',
                    shortCode: 'g'
                }
            ]
        }
    }
]
